import { FieldValidator } from 'formik';

export const validEmail: FieldValidator = (value: any) => {
  if (!value || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,14}$/i.test(value)) {
    return 'Invalid email address';
  }
};
